"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HOASvg = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M27,9c-1.38,0-3,.92-3,3.5v2.1l1.41,1.21A2.86,2.86,0,0,1,25.74,20l-3,3.56a1,1,0,1,1-1.54-1.28l2.42-3.08a1.8,1.8,0,0,0-.16-2.34h0a1.78,1.78,0,0,0-2.65.14L17.7,20.8a3,3,0,0,0-.7,1.92V29a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V27.26L29.18,22A3.7,3.7,0,0,0,30,19.7V12.5C30,10.08,28.49,9,27,9Z"/><path d="M5,9c1.38,0,3,.92,3,3.5v2.1L6.59,15.81A2.86,2.86,0,0,0,6.26,20l3,3.56a1,1,0,0,0,1.54-1.28L8.35,19.24a1.8,1.8,0,0,1,.16-2.34h0a1.78,1.78,0,0,1,2.65.14L14.3,20.8a3,3,0,0,1,.7,1.92V29a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V27.26L2.82,22A3.7,3.7,0,0,1,2,19.7V12.5C2,10.08,3.51,9,5,9Z"/><path d="M21.65,6.47l-5-4.23a1,1,0,0,0-1.3,0l-5,4.23a1,1,0,0,0-.35.76V13.5A1.5,1.5,0,0,0,11.5,15h9A1.5,1.5,0,0,0,22,13.5V7.23A1,1,0,0,0,21.65,6.47ZM17,13H15V11a1,1,0,0,1,2,0Z"/>';
var HOASvg = function HOASvg(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.HOASvg = HOASvg;
HOASvg.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(HOASvg);
exports.default = _default;